<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout=""
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="轮播图">
            <a-upload
              :default-file-list="defaultFileList"
              :customRequest="upload"
            >
              <a-button> <a-icon type="upload" /> 上传 </a-button>
            </a-upload>
            <span style="color: red"
              >tips：图片大小仅支持 宽400rpx 高830rpx</span
            >
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="轮播图位置">
            <a-select
              default-value="通用"
              style="width: 200px"
              @change="handleChange"
              v-model="formInline.store"
            >
              <a-select-option value="3"> 通用 </a-select-option>
              <a-select-option value="1">门店首页</a-select-option>
              <a-select-option value="2"> 门店详情页 </a-select-option>
              <a-select-option value="4"> 兑换商城页 </a-select-option>
              <a-select-option value="5"> 福利群二维码 </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="显示序号">
            <a-input placeholder="" v-model="formInline.storNum" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-button @click="save">保存</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { picUpload, carouseAddList } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        store: "",
        storNum: "",
        slideshowUrl: "",
      },
      defaultFileList: [],
    };
  },
  methods: {
    handleChange(value) {
      this.formInline.store = value;
    },
    goBack() {
      this.$router.push("/home/carouselManagement/carouselManagementHome");
    },
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }

      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formInline.slideshowUrl = res.data;
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
          // console.log(err);
        });
    },
    save() {
      carouseAddList({
        location: this.formInline.store,
        slideshowUrl: this.formInline.slideshowUrl,
        sortNum: this.formInline.storNum,
      }).then((res) => {
        this.$router.push("/home/carouselManagement/carouselManagementHome");
        message.success("添加成功");
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/carouselManagement/newCarousel/newCarousel.vue